module.exports = __webpack_public_path__ + "img/wf-finishing-position-24.511e7142.svg";